import { ChakraProps, HTMLChakraProps, StackProps } from "@chakra-ui/react";

const sticky: HTMLChakraProps<"div"> = {
  position: "sticky",
  top: 0,
};

export default sticky;
